export const getLangTitle = (lang: string) => {
  if (lang === 'en') return 'English';
  if (lang === 'hi') return 'Hindi';
  if (lang === 'te') return 'Telugu';
  if (lang === 'pa') return 'Punjabi';
  return lang;
};
